import ContinuePage from "@components/ContinuePage"
import { isHomeDesignFlow } from "@helpers/localStorage"

export default function DoingAmazingPage() {
  if (isHomeDesignFlow()) {
    return <ContinuePage emoji="🌟" translationKey="doingAmazingHomeDesign" />
  }
  return <ContinuePage emoji="🎯" translationKey="doingAmazing" />
}
